import { PROGRESS, REALISED_SCREEN } from 'config/config';
import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import {
  RealisedScreenContainer,
  RealisedScreenIcon,
  RealisedScreenMessage,
  RealisedScreenStatus,
  RealisedScreenStatusText,
  RealisedScreenWrapper,
} from './RealisedScreen.styles';
import withProgressBar from '../../hoc/withProgressBar';

const { status, statusText, icon, description } = REALISED_SCREEN;

const RealisedScreen = memo(() => (
  <RealisedScreenContainer className="realised-screen__container">
    <RealisedScreenWrapper>
      <RealisedScreenStatus className="realised-screen__status">
        <FormattedMessage id={status} />
      </RealisedScreenStatus>
      <RealisedScreenStatusText className="realised-screen__statusText">
        <FormattedMessage id={statusText} />
      </RealisedScreenStatusText>
      <RealisedScreenIcon className="realised-screen__icon">
        <img src={icon} alt="icon" />
      </RealisedScreenIcon>
      <RealisedScreenMessage className="realised-screen__message">
        <FormattedMessage id={description} />
      </RealisedScreenMessage>
    </RealisedScreenWrapper>
  </RealisedScreenContainer>
));

export default withProgressBar(PROGRESS.PAYMENT_SUCCESS)(RealisedScreen);
